import {lazyRegister} from "@/Core/lazyRegister";

lazyRegister.filter('skuBuild', function () {
    return (number,
            color = '') => number.substring(0, 5) + "-" + (number.substring(5) || "") + (!color ? color : '-' + color);

});